// START-CodeLeap [17-Aug-2026]: [1.0-R-UX offline navigation screen]
import { getTranslatedText } from '../../../util/util';
import usePageTranslation from '../../../hooks/ui/usePageTranslation';
import { FullPageMessageCard } from '../../../components/common/full-page-message-card/full-page-message-card';

interface OfflineScreenProps {
  onRetry: () => void;
}

export function OfflineScreen({ onRetry }: OfflineScreenProps) {
  const PageTranslation = usePageTranslation();

  return (
    <FullPageMessageCard
      title={getTranslatedText('offline.title.text', PageTranslation)}
      message={getTranslatedText('offline.message.text', PageTranslation)}
      actionLabel={getTranslatedText('offline.retry.text', PageTranslation)}
      onAction={onRetry}
    />
  );
}
// /END-CodeLeap [17-Aug-2026]: [1.0-R-UX offline navigation screen]
